export default __webpack_public_path__ + "static/media/greenback.9fe31f5a.png";